import FilterSvg from "@/assets/icons/filter.svg?react";
import { cn } from "@/lib/utils";

export  function FilterIcon({ className }: { className?: string }) {
  return <FilterSvg className={cn("shrink-0", className)} aria-hidden />;
}
